import { MatchingType } from '../../types/EquipmentTypes';

export default {
  title: 'Electrical/Electronic',
  items: [
    {
      title: 'ACBs',
      hasMaker: true,
      hasType: true,
      makers: [
        'Terasaki',
        'C&A (Danfoss)',
        'Nishishiba',
        'JRCS',
        'Morita',
        'Taiyo',
        'ABB',
        'General Electric',
        'Siemens',
        'Hyundai Electric',
        'KTE',
        'Schneider Electric',
        'Dongyang',
        'Kongsberg',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'AVR',
      hasMaker: true,
      hasType: true,
      makers: [
        'Stamford AvK',
        'Wartsila',
        'General Electric',
        'Nishishiba',
        'Terasaki',
        'Bemac',
        'Hyundai Electric',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Electric Motors',
      hasMaker: true,
      hasType: false,
      makers: [
        'ABB',
        'Hyundai Electric',
        'ATT Electric',
        'Nishishiba',
        'Rockwell Automation',
        'AC Motoren',
        'Taiyo',
        'Danfoss',
      ],
      standardServices: [
        {
          title: 'Rewinding',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Generators',
      hasMaker: true,
      hasType: true,
      makers: [
        'Stamford AvK',
        'Wartsila',
        'General Electric',
        'Nishishiba',
        'Taiyo',
      ],
      standardServices: [
        {
          title: 'Bearings Replacement',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Cleaning',
          matching: [MatchingType.EQUIPMENT, MatchingType.STANDARD_SERVICE],
        },
        {
          title: 'Exciting System Overhauling',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'MSB',
      hasMaker: true,
      hasType: true,
      makers: [
        'Terasaki',
        'C&A (Danfoss)',
        'Nishishiba',
        'JRCS',
        'Morita',
        'Taiyo',
        'ABB',
        'General Electric',
        'Siemens',
        'Hyundai Electric',
        'KTE',
        'Schneider Electric',
        'Dongyang',
        'Kongsberg',
      ],
      standardServices: [
        {
          title: 'Thermal Imaging Survey',
          matching: [MatchingType.EQUIPMENT],
        },
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
    {
      title: 'Power Management System',
      hasMaker: true,
      hasType: true,
      makers: [
        'Kongsberg',
        'Schneider Electric',
        'Wartsila',
        'Terasaki',
        'Bemac',
      ],
      standardServices: [
        {
          title: 'Other',
          matching: [MatchingType.EQUIPMENT],
        },
      ],
      items: [],
    },
  ],
};
